module.exports = __webpack_public_path__ + "img/kuwait.41603662.svg";